export const isRunInProgress = (status)=>status.status === 'inProgress';
export const isRunCancelled = (status)=>status.status === 'cancelled';
export function summaryLine(status, texts) {
    if (isRunInProgress(status)) return texts.modalSummarySending({
        total: status.total
    });
    if (isRunCancelled(status)) {
        return status.sent === 1 ? texts.modalCancelledHeadlineOne() : texts.modalCancelledHeadline({
            sent: status.sent
        });
    }
    return status.sent === 1 ? texts.modalSummarySentOne() : texts.modalSummarySent({
        sent: status.sent
    });
}
export function unreachedDraftsLine(status, texts) {
    const count = status.cancelledDraftIds.length;
    return count === 1 ? texts.modalCancelledDetailOne() : texts.modalCancelledDetail({
        count
    });
}
export function failedHeadline(failed, texts) {
    return failed === 1 ? texts.modalFailedHeadlineOne() : texts.modalFailedHeadline({
        failed
    });
}
const hasClient = (draft)=>draft.customerName.trim() !== '';
export const namedFailures = (status)=>status.failedDrafts.filter(hasClient);
export const clientlessFailureCount = (status)=>status.failedDrafts.length - namedFailures(status).length;
export function noClientHeadline(count, texts) {
    return count === 1 ? texts.modalFailedNoClientOne() : texts.modalFailedNoClient({
        failed: count
    });
}
export function failedRowDetail(draft, texts) {
    return texts.modalFailedRow({
        signatory: draft.mainSignatoryName,
        email: draft.mainSignatoryEmail
    });
}
export function modalTitle(jobName, texts) {
    return jobName ? texts.titleNamed({
        name: jobName
    }) : texts.title();
}
